export enum EnvironmentType {
  PROD = 'PROD',
  PREP = 'PREP',
  DEV = 'DEV',
}
